module.exports = __webpack_public_path__ + "static/page1-0afdd5e85758bd382194b251ec11660b.png";